import React, {Fragment} from 'react';
import {styled, useTheme} from '@mui/material/styles';
import {Container, Box} from "@mui/material";
import TopBar from "./TopBar";
import {findTopbarSetting} from "../repository/EntityRepository";
import OnlyMenuButtonTopBar from "./TopBar/OnlyMenuButtonTopBar";

const PREFIX = 'MainContainer';

const classes = {
    main: `${PREFIX}-main`
};

const StyledContainer = styled(Container)((
    {
        theme
    }
) => ({
    [`&.${classes.main}`]: {//notch :)
        paddingTop: `env(safe-area-inset-top)`,
        paddingLeft: `env(safe-area-inset-left)`,
        paddingRight: `env(safe-area-inset-right)`
    }
}));

/**
 * Just to render a fragment with all props passed to it, to avoid errors when rendering Fragments with props
 */
const FragmentWrapper = ({props, children}) => {
    return <Fragment>{children}</Fragment>
}

const MainContainer = ({children, menuItems, ...props}) => {
    const theme = useTheme();
    const { entity } = props;
    const topbarSettings = findTopbarSetting(entity)

    const selectTopbarComponent = () => {
        const DefaultTopbarComponent = props.topbar === true || props.topbar === undefined ? TopBar : props.topbar;
        if (topbarSettings && topbarSettings.style) {
            switch (topbarSettings.style) {
                case 'none':
                    return FragmentWrapper
                case 'menuButtonOnly':
                    return OnlyMenuButtonTopBar
                case 'solidFixed':
                    return TopBar
            }
        } else if (props.topbar === false) {
            return FragmentWrapper
        } else {
            return DefaultTopbarComponent
        }
    }

    const TopbarComponent = selectTopbarComponent();

    return (
        <StyledContainer maxWidth="md" className={`${classes.main} ${theme.palette.mode}`}>
            <TopbarComponent {...props} topbarSettings={topbarSettings} />
            <Box>
                <main>{children}</main>
            </Box>
        </StyledContainer>
    );
}

export default MainContainer;
